import { useHasScrolled } from "@/hooks/useHasScrolled";
import { cn } from "@/lib/utils";
import AppHeaderAlt from "../AppHeader/AppHeaderAlt";
import { ScrollArea } from "../ui/scroll-area";

const BgFlourish = () => {
  const { hasScrolled, ref } = useHasScrolled();
  return (
    <div
      className={cn(
        "absolute left-1/2 -translate-x-1/2 top-[-137vw] w-[150vw] aspect-square rounded-full bg-[#6448EF]/50 blur-[8vw] -z-10 transition-all duration-500 ease-out",
        hasScrolled && "opacity-0",
      )}
      ref={ref}
    />
  );
};

export const ProjectLandingLayout = ({
  children,
}: {
  children?: React.ReactNode;
}) => (
  <ScrollArea className="h-full relative w-full">
    <BgFlourish />
    <div className="w-full sticky top-0 z-2002">
      <AppHeaderAlt />
    </div>
    <div className="mt-[15vh] space-y-12">{children}</div>
  </ScrollArea>
);
